export const props = {
  onComplete: {
    type: Function,
    default: async () => {}
  }
}
